var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('regions-modal'),_vm._v(" "),_c(_vm.availableQuestions[_vm.currentQuestion],_vm._b({tag:"component",on:{"skip":_vm.incrementQuestion}},'component',{division: _vm.dynamic.keys.division},false)),_vm._v(" "),_c('TrustpilotMicroCombo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }